import { Box, Button, CircularProgress, Divider, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { GET_ALL_SUBORDER, GET_ORDER } from 'src/apiService/apiDeclaration';
import usePagination from 'src/hooks/usePagination';
import SecondaryTable from 'src/components/dashboardComponents/SecondaryTable';
import { customerDashboardColumns } from 'src/constants';
import OrderCard from 'src/components/dashboardComponents/OrderCard';
import { t } from 'i18next';
//console
const CustomerDashboard = () => {
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { loading, data } = usePagination(GET_ALL_SUBORDER, {
    status: '',
    customerId: user?._id,
    page: 1,
    pageSize: 5,
  });
  const [subLoading, setSubLoading] = useState(false);
  const [orderData, setOrderData] = useState([]);

  const getData = async () => {
    setSubLoading(true);
    try {
      let resp = await GET_ORDER(`pageSize=${3}&customerId=${user?._id}`);
      setOrderData(resp.data.rows);
    } catch (error) {
      console.log(error);
    } finally {
      setSubLoading(false);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNavigate = () => {
    navigate('/sub-order', { state: '' });
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="h4">{t('dashboard.orderHistory')}</Typography>
      </div>
      <SecondaryTable data={data} columns={customerDashboardColumns} loading={loading} />
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', pb: 2 }}>
        <Button disabled={data.rowCount === 0} onClick={handleNavigate}>
          {t('dashboard.viewMore')}
        </Button>
      </div>
      <Divider sx={{ mb: 4 }} />
      <Box sx={{ display: 'flex', flexDirection: 'column', mb: 4, gap: 2 }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          {t('dashboard.activeOrders')}
        </Typography>
        {orderData.length === 0 ? (
          <Box
            sx={{
              width: '100%',
              height: '30vh',
              background: '#f6f7f8',
              borderRadius: '20px',
              fontSize: '22px',
              color: '#acd629',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {subLoading ? <CircularProgress /> : t('dashboard.noActiveOrders')}
          </Box>
        ) : (
          orderData.map((order, index) => <OrderCard key={index} order={order} />)
        )}
      </Box>
    </>
  );
};

export default CustomerDashboard;
